import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const Cake: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_476_8989)">
        <circle cx="12" cy="12" r="12" fill="#37D3DE" />
        <g clip-path="url(#clip1_476_8989)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.87697 6.5C6.62461 5.2 7.63407 4 8.94637 4C10.1073 4 11.0662 4.95 11.0662 6.1V8.7C11.3691 8.7 11.6719 8.65 11.9748 8.65C12.2776 8.65 12.53 8.65 12.8328 8.7V6.1C12.8328 4.95 13.7918 4 14.9527 4C16.265 4 17.2744 5.2 17.0726 6.5L16.5173 9.55C18.4858 10.4 20 11.9 20 13.75V14.9C20 16.45 18.9905 17.75 17.5268 18.6C16.0631 19.5 14.1451 20 11.9748 20C9.80442 20 7.88644 19.5 6.42271 18.6C5.00946 17.75 4 16.45 4 14.9V13.75C4 11.9 5.46372 10.4 7.43218 9.55L6.87697 6.5ZM15.7603 9.95L16.4164 6.35C16.5678 5.45 15.9117 4.6 14.9527 4.6C14.1451 4.6 13.489 5.25 13.489 6.05V9.35C13.2871 9.3 13.0347 9.3 12.8328 9.3C12.53 9.3 12.2776 9.25 11.9748 9.25C11.6719 9.25 11.3691 9.25 11.0662 9.3C10.8644 9.3 10.612 9.35 10.4101 9.35V6.1C10.4101 5.3 9.75394 4.65 8.94637 4.65C8.03785 4.65 7.33123 5.5 7.53312 6.4L8.18927 10C6.0694 10.8 4.65615 12.2 4.65615 13.8V14.95C4.65615 17.4 7.93691 19.4 11.9748 19.4C16.0126 19.4 19.2934 17.4 19.2934 14.95V13.8C19.3438 12.15 17.9306 10.75 15.7603 9.95Z"
            fill="#F7F7F7"
          />
          <path
            d="M19.3439 14.9C19.3439 17.35 16.0631 19.35 12.0252 19.35C7.98739 19.35 4.70663 17.35 4.70663 14.9V13.75H19.3943V14.9H19.3439Z"
            fill="#FEDC90"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.53313 6.40039C7.33124 5.50039 8.03786 4.65039 8.94638 4.65039C9.75395 4.65039 10.4101 5.30039 10.4101 6.10039V9.40039C10.9148 9.35039 11.4196 9.30039 11.9748 9.30039C12.4795 9.30039 12.9842 9.35039 13.489 9.40039V6.10039C13.489 5.30039 14.1451 4.65039 14.9527 4.65039C15.8612 4.65039 16.5678 5.50039 16.4164 6.40039L15.7603 10.0004C17.8801 10.8004 19.3439 12.2004 19.3439 13.8004C19.3439 16.2504 16.0631 18.2504 12.0252 18.2504C7.98739 18.2504 4.70663 16.2504 4.70663 13.8004C4.70663 12.2004 6.11988 10.8004 8.23976 10.0004L7.53313 6.40039Z"
            fill="#D1884F"
          />
          <path
            d="M9.95584 13.45C9.95584 14.1 9.60253 14.65 9.14827 14.65C8.69401 14.65 8.3407 14.1 8.3407 13.45C8.3407 12.8 8.69401 12.25 9.14827 12.25C9.60253 12.25 9.95584 12.8 9.95584 13.45Z"
            fill="#633001"
          />
          <path
            d="M15.5583 13.45C15.5583 14.1 15.205 14.65 14.7508 14.65C14.2965 14.65 13.9432 14.1 13.9432 13.45C13.9432 12.8 14.2965 12.25 14.7508 12.25C15.205 12.25 15.5583 12.8 15.5583 13.45Z"
            fill="#633001"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_476_8989">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_476_8989">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Cake;
